import type { MealStatus } from '../enums/MealStatus'

export class MealStatusLogEntity {
  id?: string
  status?: MealStatus
  date?: string
}
